import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { routes } from "../routes";

// Guard : n'autorise l'accès aux routes enfants que si l'utilisateur est connecté.
// L'auth est synchrone (token en localStorage), pas d'état "Pending" à gérer.
// Le contrôle d'admission (allowlist) est fait ensuite par le Layout via api.me.
export function AuthRequired() {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Navigate to={routes.login()} replace />;
  return <Outlet />;
}
